// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3cCOf","emails":"CreateEditClinics_emails__FzyBA","emailTagLabel":"CreateEditClinics_emailTagLabel__YcRQ4"};